module.exports = __webpack_public_path__ + "img/theme-b.a0a92255.png";